<template>
  <div
    class="flex min-h-screen items-center justify-center bg-gray-50 px-4 py-12"
  >
    <div class="w-full max-w-sm">
      <div class="rounded-2xl bg-white p-10 text-center shadow-xl">
        <div
          class="mx-auto mb-4 flex h-20 w-20 items-center justify-center rounded-full bg-green-50"
        >
          <svg
            class="h-10 w-10 text-green-600"
            fill="none"
            stroke="currentColor"
            stroke-width="2.5"
            stroke-linecap="round"
            stroke-linejoin="round"
            viewBox="0 0 24 24"
          >
            <polyline points="20 6 9 17 4 12" />
          </svg>
        </div>

        <h1 class="text-xl font-semibold text-gray-900">
          Verification Complete
        </h1>
        <p class="mt-2 text-sm text-gray-500">
          Your ID has been submitted successfully. You may close this window.
        </p>

        <div class="mt-6 rounded-xl bg-gray-50 p-4">
          <div class="flex items-center justify-between">
            <span class="text-sm text-gray-500">Name</span>
            <span class="text-sm font-medium text-gray-900">{{
              participantName
            }}</span>
          </div>
          <div class="mt-2 flex items-center justify-between">
            <span class="text-sm text-gray-500">Status</span>
            <span
              class="rounded-full bg-green-50 px-3 py-0.5 text-xs font-medium text-green-600"
            >
              Submitted
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
defineProps<{
  token: string
  participantName: string
  status: string
}>()

defineOptions({ layout: false })
</script>
